// extracted by mini-css-extract-plugin
export default {"root":"La_h6zljKM5MUK7bvKex","separator":"sfI4rqlw0EGY7KStvMa1","crumb":"DNfxAZs2F9fd7BnJ4kq6","stretch":"zlztJ_lG_IVQSC3kLLI6"};